import React, { useState,useEffect } from "react";
import { Grid, Paper } from "@material-ui/core";
import {
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  Button,
  Box,
  TableBody,
  FormControl,
  Select,
  MenuItem,
  TextField,
  TablePagination,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import moment from "moment/moment";

import EmptyData from "../../../../../StyledComponents/Table/EmptyData";
import Heading from "../../../../../StyledComponents/Heading/Heading";

const useStyles = makeStyles({
  table: {
    minWidth: 650,
    "& .MuiTableCell-root": {
      borderLeft: "1px solid rgba(224, 224, 224, 1)",
    },
    // tablebody: {
    //   "&.MuiTableRow-root:last-child td": {
    //     borderLeft: "1px solid #000",
    //   },
    // },
  },
});

function FER_General({ multipleData }) {
  const classes = useStyles();
  const [page, setpage] = useState(0);
  const [RowsPerPage, setRowsPerPage] = useState(10);
  const handleChangePage = (event, newPage) => {
    setpage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value));
    setpage(0);
  };
  
  const [generalTable, setGeneralTable] = useState([]);
  useEffect(() => {
    // Process the data and update state for each table
    const processTables = () => {
      
      const generalTableData = [];
      

      for (let i = 0; i <  multipleData?.fer_Invoice_Detial?.length; i++) {
        const record =  multipleData?.fer_Invoice_Detial[i];
      
         if (record.Category === "General") {
          generalTableData.push(record);
        }
      }

   
      setGeneralTable(generalTableData);
    
    };

    processTables();
  }, [multipleData]);
  return (
    <div>
      <Grid container>
        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          lg={12}
          mt={2}
          mb={2}
          style={{ width: "0" }}
        >
          <Heading title="General" />
          <TableContainer
            className="scrollable"
            // style={{
            //   maxHeight: "200px",
            //   minHeight: "100px",
            //   overflowX: "auto",
            // }}
          >
            <Table
              className={classes.table}
              aria-label="a dense table"
              // padding="normal"
              size="small"
            >
              <TableHead>
                <TableRow sx={{ backgroundColor: "#EFF2F4", fontSize: "11" }}>
                  <TableCell
                    sx={{ fontWeight: "bold", color: "#031C30", p: 1 ,width:"22%"}}
                  >
                    Expense Date
                  </TableCell>
                  <TableCell
                    sx={{ fontWeight: "bold", color: "#031C30", p: 1,width:"22%" }}
                  >
                  Vehicle No
                  </TableCell>
                  <TableCell
                    sx={{ fontWeight: "bold", color: "#031C30", p: 1,width:"22%" }}
                  >
                     Vehicle Type
                  </TableCell>
                  <TableCell
                    sx={{ fontWeight: "bold", color: "#031C30", p: 1 ,width:"22%"}}
                  >
                  Rail/Road Tax

                  </TableCell>
                  <TableCell
                    sx={{ fontWeight: "bold", color: "#031C30", p: 1 ,width:"22%"}}
                  >
                   Hotel Expenses

                  </TableCell>
                  <TableCell
                    sx={{ fontWeight: "bold", color: "#031C30", p: 1,width:"22%" }}
                  >
                    Staff Meeting

                  </TableCell>
                  <TableCell
                    sx={{ fontWeight: "bold", color: "#031C30", p: 1,width:"22%" }}
                  >
                   Meetings with BP

                  </TableCell>
                  <TableCell
                    sx={{ fontWeight: "bold", color: "#031C30", p: 1 ,width:"22%"}}
                  >
                   Postage/Courier

                  </TableCell>
                  <TableCell
                    sx={{ fontWeight: "bold", color: "#031C30", p: 1,width:"22%"}}
                  >
                    Photocopy Stationary

                  </TableCell>
                  <TableCell
                    sx={{ fontWeight: "bold", color: "#031C30", p: 1,width:"22%" }}
                  >
                   Non Cap

                  </TableCell>
                  <TableCell
                    sx={{ fontWeight: "bold", color: "#031C30", p: 1 }}
                  >
                   Internet

                  </TableCell>
                  <TableCell
                    sx={{ fontWeight: "bold", color: "#031C30", p: 1,width:"22%" }}
                  >
                   Driver Salary
                  </TableCell>
                  <TableCell
                    sx={{ fontWeight: "bold", color: "#031C30", p: 1 }}
                  >
                   Misc GL

                  </TableCell>
                  <TableCell
                    sx={{ fontWeight: "bold", color: "#031C30", p: 1 }}
                  >
                  Misc Amount

                  </TableCell>
                  <TableCell
                    sx={{ fontWeight: "bold", color: "#031C30", p: 1 }}
                  >
                  Misc GL

                  </TableCell>
                  <TableCell
                    sx={{ fontWeight: "bold", color: "#031C30", p: 1 }}
                  >
                   Misc Amount

                  </TableCell>
                  <TableCell
                    sx={{ fontWeight: "bold", color: "#031C30", p: 1 }}
                  >
                   Misc GL
                  </TableCell>
                  <TableCell
                    sx={{ fontWeight: "bold", color: "#031C30", p: 1 }}
                  >
                   Misc Amount

                  </TableCell>
                  <TableCell
                    sx={{ fontWeight: "bold", color: "#031C30", p: 1 ,width:"22%"}}
                  >
                 Expense Description/Remarks

                  </TableCell>
                  <TableCell
                    sx={{ fontWeight: "bold", color: "#031C30", p: 1 ,width:"22%"}}
                  >
                 Total Expense Amount

                  </TableCell>

                
                </TableRow>
              </TableHead>
              <TableBody>
                {generalTable.length > 0 &&
                  generalTable
                    ?.slice(
                      page * RowsPerPage,
                      page * RowsPerPage + RowsPerPage
                    )
                    .map((item, index) => {
                      return (
                        <TableRow key={index} sx={{ fontSize: "10" }}>
                            <TableCell sx={{ p: 1 }}>{moment(item?.ExpenseDate).format("MM/DD/YYYY")}</TableCell>
                          <TableCell sx={{ p: 1 }}>{item?.Vehicle_No}</TableCell>
                          <TableCell sx={{ p: 1 }}>{item?.Vehicle_Type}</TableCell>
                          <TableCell sx={{ p: 1 }}>{item?.Rail_Road_Tax}</TableCell>
                          <TableCell sx={{ p: 1 }}>{item?.Hotel_Expenses}</TableCell>
                          <TableCell sx={{ p: 1 }}>{item?.Staff_Meeting}</TableCell>
                          <TableCell sx={{ p: 1 }}>{item?.Meeting_With_BP}</TableCell>
                          <TableCell sx={{ p: 1 }}>{item?.Postage_Courier}</TableCell>
                          <TableCell sx={{ p: 1 }}>{item?.Photocopy_Stationary}</TableCell>
                          <TableCell sx={{ p: 1 }}>{item?.Non_Cap}</TableCell>
                          <TableCell sx={{ p: 1 }}>{item?.Internet}</TableCell>
                          <TableCell sx={{ p: 1 }}>{item?.Driver_Salary}</TableCell>
                          <TableCell sx={{ p: 1 }}>{item?.Misc_GL_1}</TableCell>
                          <TableCell sx={{ p: 1 }}>{item?.Misc_GL_Amount_1}</TableCell>
                          <TableCell sx={{ p: 1 }}>{item?.Misc_GL_2}</TableCell>
                          <TableCell sx={{ p: 1 }}>{item?.Misc_GL_Amount_2}</TableCell>
                          <TableCell sx={{ p: 1 }}>{item?.Misc_GL_3}</TableCell>
                          <TableCell sx={{ p: 1 }}>{item?.Misc_GL_Amount_3}</TableCell>
                          <TableCell sx={{ p: 1 }}>{item?.Expense_Remarks}</TableCell>
                          <TableCell sx={{ p: 1 }}>{item?.Total_Expense_Amount}</TableCell>
                        </TableRow>
                      );
                    })}
              </TableBody>
              {/* {loading && <TableSkeleton noOfColumns={9} noOfLines={3} />} */}
            </Table>
            {generalTable?.length === 0 ? <EmptyData /> : ""}
            <TablePagination
              rowsPerPageOptions={[10, 20, 30]}
              component="div"
              count={generalTable?.length}
              rowsPerPage={RowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </TableContainer>
        </Grid>
      </Grid>
    </div>
  );
}

export default FER_General;
